export default __webpack_public_path__ + "static/media/remind-small.1dddf4fc.svg";